import { render, staticRenderFns } from "./PsPatientsDetail.vue?vue&type=template&id=462f8c52&scoped=true&"
import script from "./PsPatientsDetail.vue?vue&type=script&lang=js&"
export * from "./PsPatientsDetail.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientsDetail.vue?vue&type=style&index=0&id=462f8c52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462f8c52",
  null
  
)

export default component.exports